import { render, staticRenderFns } from "./chat-notification.vue?vue&type=template&id=def8db70&scoped=true"
import script from "./chat-notification.vue?vue&type=script&lang=js"
export * from "./chat-notification.vue?vue&type=script&lang=js"
import style0 from "./chat-notification.vue?vue&type=style&index=0&id=def8db70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def8db70",
  null
  
)

export default component.exports